import React from 'react'
import { Modal } from '@mantine/core'
import DealsForm from './deal-details/deal-form'
import { CustomLoaderPage } from 'app/views/components/loader/loader-page'

type Props = {
  deal?: any
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  useStepper?: boolean
  amendment?: any
  /** Show a loader instead of the form while its lookup data is still being fetched. */
  loading?: boolean
}

export const DealsModal: React.FC<Props> = ({
  open,
  setOpen,
  deal,
  useStepper,
  amendment,
  loading = false,
}: Props) => {
  return (
    <Modal
      className="modal-body modal-body-template fit-content-modal"
      opened={open}
      onClose={() => setOpen(false)}
      centered={true}
      size="77%"
    >
      {loading ? (
        <CustomLoaderPage />
      ) : (
        <DealsForm
          closeModal={() => setOpen(false)}
          amendment={amendment}
          deal={deal ?? {}}
          useStepper={useStepper}
        />
      )}
    </Modal>
  )
}
